import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "w-lg-900px bg-white rounded shadow-sm p-10 p-lg-15 mx-auto" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "text-center mb-10" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "text-dark mb-3" }, "Forgot Password ?"),
  /*#__PURE__*/_createElementVNode("div", { class: "text-gray-400 fw-bold fs-4" }, " Enter your email to reset your password. ")
], -1)
const _hoisted_3 = {
  class: "fv-row mb-10 mx-auto",
  style: {"max-width":"600px"}
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bolder text-gray-900 fs-6" }, "Email", -1)
const _hoisted_5 = { class: "fv-plugins-message-container" }
const _hoisted_6 = { class: "fv-help-block" }
const _hoisted_7 = { class: "d-flex flex-wrap justify-content-center pb-lg-0" }
const _hoisted_8 = ["data-kt-indicator"]
const _hoisted_9 = {
  key: 0,
  class: "indicator-label"
}
const _hoisted_10 = {
  key: 1,
  class: "indicator-progress"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Form, {
      onSubmit: _cache[1] || (_cache[1] = ($event: any) => (_ctx.formSubmit())),
      class: "form w-100 fv-plugins-bootstrap5 fv-plugins-framework",
      id: "kt_login_password_reset_form",
      "validation-schema": _ctx.PassResetSchema
    }, {
      default: _withCtx(() => [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createVNode(_component_Field, {
            modelValue: _ctx.email,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.email) = $event)),
            class: "form-control form-control-solid",
            type: "email",
            placeholder: "",
            name: "email",
            autocomplete: "off"
          }, null, 8, ["modelValue"]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_ErrorMessage, { name: "email" })
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("button", {
            "data-kt-indicator": _ctx.loading ? 'on' : null,
            type: "submit",
            ref: "submitButton",
            id: "kt_password_reset_submit",
            class: "btn btn-lg btn-primary fw-bolder me-4"
          }, [
            (!_ctx.loading)
              ? (_openBlock(), _createElementBlock("span", _hoisted_9, " Send Password Reset Link "))
              : _createCommentVNode("", true),
            (_ctx.loading)
              ? (_openBlock(), _createElementBlock("span", _hoisted_10, [
                  _createTextVNode(" Please wait... "),
                  _hoisted_11
                ]))
              : _createCommentVNode("", true)
          ], 8, _hoisted_8),
          _createVNode(_component_router_link, {
            to: "/sign-in",
            class: "btn btn-lg btn-light-primary fw-bolder"
          }, {
            default: _withCtx(() => [
              _createTextVNode("Cancel")
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["validation-schema"])
  ]))
}